import React from 'react'

import EncoderListing from './EncoderListing'
import encoderSelectDisabled from './encoderSelectDisabled'

const EncoderSelector = (props) => {
  const { event, encoders, assignEncoder, isResolving, startStopPending, actions } = props
  const encodersDisabled = encoderSelectDisabled({
    eventStatus: event.eventStatus,
    startStopPending
  })

  return (
    <div className='event-encoder-select'>
      <EncoderListing
        event={event}
        encoders={encoders}
        disabled={encodersDisabled}
        assignEncoder={assignEncoder}
        isResolving={isResolving}
        actions={actions}
      />
    </div>
  )
}

export default EncoderSelector